module.exports = __webpack_public_path__ + "img/help.36f41b31.svg";